// The roles an account can be given, and how they read in the interface.
//
// Mirrors ALL_ROLES in finadmin_server/server/users/roleLifecycle.js. The two
// repositories share no package, so this is a copy. It is display metadata: the
// server validates every role it is sent against its own list, so a stale or
// wrong entry here produces a clear error from the server rather than a role
// nobody expected.
//
// `label` is the short form shown wherever a role is named in passing - a chip,
// a preview. `description` is the longer form offered in the picker, where there
// is room to say what the role actually grants.
export const ROLE_OPTIONS = [
    {
        value: 'superAdmin',
        label: 'Super administrator',
        description: 'Manages users and roles',
    },
    {
        value: 'admin',
        label: 'Administrator',
        description: 'Beneficiary records and visits',
    },
    {
        value: 'handler',
        label: 'Handler',
        description: 'Day-to-day beneficiary records',
    },
    {
        value: 'sponsor',
        label: 'Sponsor',
        description: 'Read access as a sponsor',
    },
    {
        value: 'etAdmin',
        label: 'ET administrator',
        description: 'ET administration',
    },
    {
        value: 'beAdmin',
        label: 'BE administrator',
        description: 'BE administration',
    },
    {
        value: 'finance',
        label: 'Finance',
        description: 'Prepares a payment month',
    },
    {
        value: 'financeAdmin',
        label: 'Finance administrator',
        description: 'Also approves and marks a month paid',
    },
];

// Falls back to the raw value rather than to nothing: an unrecognised role is
// something the reader needs to see, not have hidden.
export const roleLabel = value => {
    const found = ROLE_OPTIONS.find(option => option.value === value);
    return found ? found.label : value;
};

// Guarded by requireUserManagement in the resolver, not by this check. The menu
// entry is hidden on the same condition as a convenience; the page and the
// mutations behind it refuse anyone else.
//
// superAdmin only. The handover is closed: this briefly also admitted 'admin',
// because no superAdmin account existed and without one nobody could reach the
// page that appoints the first. A superAdmin now exists, so administrators are
// refused again - which is what keeps an administrator from minting an
// administrator. The server-side counterpart is USER_MANAGEMENT_ROLES in
// finadmin_server/server/auth/roles.js; both must be changed together.
export const canManageUsers = permissions =>
    !!permissions && permissions.includes('superAdmin');
